export default __webpack_public_path__ + "static/media/calculatorOn.97ae5a1a.svg";